require("!!/Users/paspao/workspaceForMaven/libri/libriweb/node_modules/script-loader/addScript.js")(require("!!/Users/paspao/workspaceForMaven/libri/libriweb/node_modules/raw-loader/index.js!/Users/paspao/workspaceForMaven/libri/libriweb/node_modules/source-map-loader/index.js!/Users/paspao/workspaceForMaven/libri/libriweb/src/js/openseadragon/openseadragon.js"))


//////////////////
// WEBPACK FOOTER
// /Users/paspao/workspaceForMaven/libri/libriweb/node_modules/script-loader!/Users/paspao/workspaceForMaven/libri/libriweb/src/js/openseadragon/openseadragon.js
// module id = ../../../../script-loader/index.js!../../../../../src/js/openseadragon/openseadragon.js
// module chunks = scripts